import PlatformInstruction from "./PlatformInstruction";
export default PlatformInstruction;